import React from 'react';
import CallsTab from '../components/AICenter/CallsTab';

// AI sesli asistanın (ElevenLabs) yanıtladığı telefon aramalarının kaydı - eskiden
// tenant'taki AI Center'ın "Çağrılar" sekmesindeydi, AI modülü yönetim paneline
// taşınırken (bkz. AdminAICenterPanel) buradan da kalkmıştı. CallsTab.js hiç
// değiştirilmeden (apiBase/token verilmeden, kendi varsayılanı /api/callops +
// crm_token ile) yeniden kullanılıyor - backend zaten değişmedi.
function Calls() {
  return (
    <div>
      <div className="header">
        <div>
          <h1 className="page-title">Çağrılar</h1>
          <p className="page-subtitle">AI'nin yanıtladığı telefon aramalarını, ses kayıtlarını ve özetlerini buradan takip edin.</p>
        </div>
      </div>
      <CallsTab />
    </div>
  );
}

export default Calls;
